import { render, staticRenderFns } from "./PeopleWidget.vue?vue&type=template&id=5bf03986"
import script from "./PeopleWidget.vue?vue&type=script&lang=js"
export * from "./PeopleWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports